// import React from 'react'

// const GenerateQR = () => {
//   return (
//     <div>

//     </div>
//   )
// }

// export default GenerateQR

//imports
import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import AppBar from "@mui/material/AppBar";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddToolbar from "../../components/common/AddToolbar";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import { Chip } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import { Toolbar, Typography } from "@mui/material";
import Alert from "@mui/material/Alert";
import { Slide } from "@mui/material";
import { QR_URL, QR_URL_R } from "../../api/EndPoints";
import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";
import {
  MAPLOCATION_API_01,
  SETTINGS_API_05,
  SHOP_API_01,
  SHOP_API_02,
} from "../../api/ApiModel";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";
import {
  IconButton,
  Tooltip,
  TableCell,
  Checkbox,
  TableRow,
  Table,
  TableBody,
  TableHead,
  Paper,
  TablePagination,
  TableContainer,
  Autocomplete,
} from "@mui/material";
import { QRCodeCanvas, QRCodeSVG } from "qrcode.react";
import { STS, CHAINCODE, MENUTYPECODE } from "../../api/ApiModel";
import { useSelector } from "react-redux";
const GenerateQR = () => {
  //hooks
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const location = useLocation();
  const [currentQRCode, setCurrentQRCode] = useState(""); // State to store the current QR code value
  const SYS_USER = useSelector((state) => state.user) || {};
  const [selectedLocCode, setSelectedLocCode] = useState("");
  const [filteredData, setFilteredData] = useState(null);
  const { COMPCODE, LOCCODE, RESTCODE, USERREFCODE, USERNAME, GROUPCODE } =
    SYS_USER.USER_PARAM || {};
  const [selectedLOC, setSelectedLOC] = useState("");
  const [dataloc, setDataloc] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRestCode, setSelectedRestCode] = useState("");
  const { selectedItem } = location.state || {};
  const [errors, setErrors] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  useEffect(() => {
    fetchData();
  }, [selectedItem]);

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const fetchData = async () => {
    try {
      const result = await externalgetApi(SHOP_API_01, "get", {
        COMPCODE: COMPCODE,
        GROUPCODE: GROUPCODE,
        USERNAME: USERNAME,
        STS: CON_STATUS_ACTIVE,
      });
      setData(result);
      const filteredResult = result.filter(
        (item) => item.RESTCODE === selectedItem.RESTCODE
      );
      setFilteredData(filteredResult);
      console.log("result", filteredResult);
      setIsLoading(false);
    } catch (err) {
      console.error("Error fetching data:", err);
      setIsLoading(false);
    }
  };

  const handleGenerateQRCode = (restCode) => {
    // Find the corresponding item from filteredData based on the restCode
    const selectedItem = filteredData.find(
      (item) => item.RESTCODE === restCode
    );

    if (!selectedItem) {
      console.error("Selected item not found for RESTCODE:", restCode);
      return;
    }

    // Use selectedItem.LOCCODE in the QR URL
    const qrCodeUrl =
      selectedItem.BUSINESSTYPECODE === "R"
        ? `${QR_URL_R}Guest?compcode=${encodeURIComponent(
            btoa(COMPCODE)
          )}&loccode=${encodeURIComponent(
            btoa(selectedItem.LOCCODE)
          )}&restcode=${encodeURIComponent(btoa(restCode))}`
        : `${QR_URL}Guest?compcode=${encodeURIComponent(
            btoa(COMPCODE)
          )}&loccode=${encodeURIComponent(
            btoa(selectedItem.LOCCODE)
          )}&restcode=${encodeURIComponent(btoa(restCode))}`;

    setCurrentQRCode(qrCodeUrl);
    setSelectedRestCode(restCode);

    console.log("Generated QR Code URL:", qrCodeUrl);
  };

  const base64QRCode = btoa(currentQRCode);

  const handleConfirm = async () => {
    if (selectedRestCode && currentQRCode) {
      const selectedRestaurant = data.find(
        (item) => item.RESTCODE === selectedRestCode
      );
      if (selectedRestaurant) {
        try {
          const response = await externalpostApi(SHOP_API_02, {
            restCode: String(selectedRestCode),
            QRCODE: base64QRCode,
            ADDRESS1: selectedRestaurant.ADDRESS1,
            ADDRESS2: selectedRestaurant.ADDRESS2,
            ADDRESS3: selectedRestaurant.ADDRESS3,
            BUSINESSTYPECODE: selectedRestaurant.BUSINESSTYPECODE,
            CATTYPE: selectedRestaurant.CATTYPE,
            COMPCODE: COMPCODE,
            DESCRIPTION: selectedRestaurant.DESCRIPTION,
            EMAIL: selectedRestaurant.EMAIL,
            ENUSER: selectedRestaurant.ENUSER,
            FAX: selectedRestaurant.FAX,
            HOTLINE: selectedRestaurant.HOTLINE,
            INVSEQNO: String(selectedRestaurant.INVSEQNO),
            ISCHAIN: selectedRestaurant.ISCHAIN,
            LOCCODE: selectedRestaurant.LOCCODE,
            LOCDATE: new Date(),
            OPRDATE: selectedRestaurant.OPRDATE,
            OPSTS: selectedRestaurant.OPSTS,
            RESPIN: selectedRestaurant.RESPIN,
            RESTNAME: selectedRestaurant.RESTNAME,
            SALESSTYLETYPE: selectedRestaurant.SALESSTYLETYPE,
            STS: selectedRestaurant.STS,
          });

          console.log("Success: true", response);
          fetchData();
          setOpenSnackbar(true);
          // Handle success (e.g., show a success message, reset form, etc.)
        } catch (error) {
          console.error("Error:", error);
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            setErrors(error.response.data.errors);
          } else {
            // Handle other errors
          }
        }
      }
    }
  };

  const gotToPage = () => {
    navigate("/ViewShop");
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const result = await externalgetApi(MAPLOCATION_API_01, "get", {
  //         COMPCODE,
  //         USERREFCODE,
  //         USERNAME,
  //         STS: "A", // Fetch only items where STS is 'A'
  //       });
  //       const filteredLocations = result;
  //       console.log("Filtered Locations:", filteredLocations);
  //       setDataloc(filteredLocations);
  //     } catch (err) {
  //       console.error("Error fetching data:", err);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  // const handleSelectionloc = (newValue) => {
  //   if (newValue && newValue.LOCCODE) {
  //     setSelectedLOC(newValue);
  //     setSelectedLocCode(newValue.LOCCODE);
  //   } else {
  //     setSelectedLocCode("");
  //     setSelectedLOC(null);
  //   }
  // };

  // useEffect(() => {
  //   if (Array.isArray(dataloc) && dataloc.length > 0 && !selectedLOC) {
  //     setSelectedLOC(dataloc[0]); // Set the first item as the default
  //     setSelectedLocCode(dataloc[0].LOCCODE); // Set the first item's LOCCODE as the default
  //   }
  // }, [dataloc, selectedLOC]);

  // useEffect(() => {
  //   if (selectedLocCode && Array.isArray(data)) {
  //     const filtered = data.filter((item) => item.LOCCODE === selectedLocCode);
  //     setFilteredData(filtered);
  //   } else {
  //     setFilteredData(data);
  //   }
  // }, [selectedLocCode, data]);

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Shop</Link>
                <Link underline="none">Generate QR</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack2,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToPage}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                  id="btnback"
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      <Box sx={styles.box_container_add}>
        <Grid item xs={12}>
          <Box sx={styles.col_title}>
            <Typography variant="title" align="left">
              Generate QR Code
            </Typography>
          </Box>
        </Grid>
        <Grid container spacing={2} pt={2}>
          <Grid item xs={12} sm={12} md={6}>
            <Box
              p={1}
              sx={{
                ...styles.AddStyledBoxpay,
                height: {
                  xs: "65vh",
                  sm: "65vh",
                  md: "65vh",
                  lg: "65vh",
                  xl: "65vh",
                },
              }}
            >
              <Grid item xs={12} sm={12} md={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box sx={styles.col_title} p={2}>
                      <Typography variant="title" align="left">
                        Shops Details
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <TableContainer
                sx={{
                  // ...styles.VI_ViewStyledPaperpay
                  mt: 2,
                }}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow
                      sx={{ background: theme.palette.background.paper }}
                    >
                     
                      <TableCell sx={{ fontWeight: "bold" }}>
                        Shop Name
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: "bold" }}>
                        View QR
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        Generate QR
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredData && filteredData.length > 0 ? (
                      filteredData.map((row, index) => {
                        const decodedQRCode = atob(row.QRCODE); // Decode the base64 QRCODE
                        return (
                          <TableRow key={index}>
                            <TableCell sx={{
                              display:"none"
                            }}>{row.RESTCODE}</TableCell>
                            <TableCell>{row.RESTNAME}</TableCell>
                            <TableCell>
                              {typeof row.QRCODE === "string" &&
                              row.QRCODE.trim() ? (
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <QRCodeSVG value={decodedQRCode} size={150} />
                                </Box>
                              ) : (
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    width: "60px",
                                    height: "60px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    backgroundColor: "#fff", // White box as default
                                  }}
                                />
                              )}
                            </TableCell>
                            <TableCell>
                              <Button
                                variant="contained"
                                sx={{
                                  background: theme.palette.primary.main,
                                  color: theme.palette.text.buttontxt,
                                  textTransform: "capitalize",
                                  width: "120px",
                                }}
                                onClick={() =>
                                  handleGenerateQRCode(row.RESTCODE)
                                }
                              >
                                Generate QR
                              </Button>
                            </TableCell>
                          </TableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        <TableCell colSpan={4} align="center">
                          No data available
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <Box
              p={1}
              sx={{
                ...styles.cb_col_1,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                textAlign: "left",

                p: 1,

                height: {
                  xs: "65vh",
                  sm: "65vh",
                  md: "65vh",
                  lg: "65vh",
                  xl: "65vh",
                },
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
              }}
            >
              {" "}
              <Box sx={{ ...styles.col_title, width: "100%" }} p={2}>
                <Typography variant="title" align="left">
                  QR Code
                </Typography>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: 2,
                }}
              >
                {currentQRCode ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "260px",
                      height: "260px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                  >
                    <QRCodeSVG value={currentQRCode} size={148} />
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "260px",
                      height: "260px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                  >
                    <Typography sx={{ color: "#888" }}>
                      Click "Generate QR" to view the QR Code.
                    </Typography>
                  </Box>
                )}

                <Stack direction="row" spacing={2} alignItems="center" mt={2}>
                  {/* Default pagination actions */}

                  {/* Custom button */}
                  <Button
                    sx={{
                      background: theme.palette.primary.main,
                      color: theme.palette.text.buttontxt,
                      textTransform: "capitalize",
                      width: "120px",
                    }}
                    variant="contained"
                    color="primary"
                    onClick={handleConfirm}
                  >
                    Confirm
                  </Button>
                </Stack>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {" Created Successfully!"}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default GenerateQR;
